export default __webpack_public_path__ + "static/media/ridgeback.ad9820d0.png";